export const ACTIVE_JOB_STATUSES = new Set([
  'accepted',
  'pending',
  'working',
  'active',
  'in-progress',
  'in_progress',
  'partial',
  'partial-result',
  'partial_result',
  'progress',
  'waiting',
  'running',
  'started',
  'queued',
  'received',
  'retry',
  'retrying',
  'delayed',
]);

export const TERMINAL_JOB_STATUSES = new Set([
  'success',
  'succeeded',
  'failure',
  'failed',
  'error',
  'completed',
  'processed',
  'stuck',
  'not_found',
  'not-found',
  'revoked',
  'canceled',
  'cancelled',
  'terminated',
  'cleared',
  'reporting_incomplete',
  'superseded',
  'expired',
  'timed-out',
  'timed_out',
  'timeout',
]);

export const SUCCESS_JOB_STATUSES = new Set(['success', 'succeeded', 'completed', 'processed']);
export const CANCELLED_JOB_STATUSES = new Set([
  'revoked', 'canceled', 'cancelled', 'terminated', 'cleared',
]);

export const isTerminalFailureStatus = status => {
  const normalized = typeof status === 'string' ? status.toLowerCase() : '';
  return TERMINAL_JOB_STATUSES.has(normalized)
    && !SUCCESS_JOB_STATUSES.has(normalized)
    && !CANCELLED_JOB_STATUSES.has(normalized);
};

export const SUPPORTED_JOB_STATUSES = new Set([
  ...ACTIVE_JOB_STATUSES,
  ...TERMINAL_JOB_STATUSES,
]);

export const sanitizeJobLog = value => (
  Array.isArray(value)
    ? value
      .filter(line => typeof line === 'string')
      .map(line => line.slice(0, 4096))
      .slice(-200)
    : []
);
